import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-local-loader',
  templateUrl: './local-loader.component.html',
  styleUrls: ['./local-loader.component.scss']
})
export class LocalLoaderComponent implements OnInit {

  @Input() enabled: boolean;

  constructor() { }

  ngOnInit() {
  }

}
